<template>
    <div class="home" v-if="pageCode">
        <commonHeader
            :swiperList="indexList"
            @changePageCode="onChange"
        />
        <EntiretyHome v-if="pageCode !== '06' && pageCode !== '07' && pageCode !== '08'"/>
        <OperateHome v-else/>
    </div>
</template>
<script>
import { getUserPageCode, setUserPageCode, setUserPageName } from '@/utils/auth'
import EntiretyHome from '../entirety/EntiretyHome.vue'
import OperateHome from '../operate/Operate.vue'
import commonHeader from '../common/commonHeader.vue'
export default {
    components: {
        EntiretyHome, OperateHome, commonHeader
    },
    data () {
        return {
            pageCode: null,
            indexList: []
        }
    },
    created () {
        sessionStorage.removeItem('fromType')
    },
    computed: {
        getPageCode () {
            return this.$store.state.user.pageCode
        }
    },
    watch: {
        getPageCode () {
            this.pageCode = this.getPageCode
        }
    },
    mounted () {
        this.pageCode = this.$store.state.user.pageCode
        this.indexList = this.$store.state.user.moduleInfo
        if (getUserPageCode()) {
            this.pageCode = getUserPageCode()
        } else {
            this.pageCode = this.indexList[0].pageCode
            setUserPageName(this.indexList[0].pageName)
        }
        setUserPageCode(this.pageCode)
        this.$store.commit('USER_SET_PAGE_CODE', this.pageCode)
    },
    methods: {
        onChange (data) {
            setUserPageCode(data.pageCode)
            setUserPageName(data.pageName)
            this.$store.commit('USER_SET_PAGE_CODE', data.pageCode)
            this.$store.commit('SET_HEADER_FLAG', true)
        }
    }
}
</script>
<style lang="stylus" scoped>
.home {
    height: 100%;
    .header {
        padding-left: 0.05rem;
    }
    .middle {
        height: 2.2rem;
        background: #dfdfdf;
    }
    .indexList {
        padding: 0.1rem;
        .indexImg {
            width: 0.36rem;
        }
        .indexName {
            font-size: 0.14rem;
            padding-top: 0.1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue